import { forwardRef, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@/components/common/modal/modal';
import PwaGuideImage from '@/components/pwa-prompt/pwa-guide-image';
import type { ModalAction } from '../common/modal/modal.type';

const PwaGuideModal = forwardRef<ModalAction, Record<string, unknown>>((_, ref) => {
  const { t } = useTranslation();
  const actionsRef = useRef<ModalAction | null>(null);

  const handleCancel = () => {
    handleCancel();
    actionsRef.current?.close();
  };

  return (
    <Modal
      ref={(r) => {
        actionsRef.current = r;
        if (typeof ref === 'function') {
          ref(r);
        } else if (ref) {
          ref.current = r;
        }
      }}
      contentClassName='p-4'>
      <div className='flex w-full gap-2 items-center flex-col'>
        <PwaGuideImage />

        <button
          onClick={() => actionsRef.current?.close()}
          className='btn btn-secondary btn-sm'>
          {t('common.close')}
        </button>
      </div>
    </Modal>
  );
});

PwaGuideModal.displayName = 'PwaGuideModal';

export default PwaGuideModal;
